<template>
    <div class="container">
        <div class="filter-container">
            <el-form :model="ruleData" ref="ruleForm" style="margin-top:20px">
                <!-- 分析对象 events -->
                <div class="analy-box" v-for="(eventItem,eventIndex) in ruleData.events" :key="eventIndex">
                    <!-- 对象列 -->
                    <div class="object-box filter-data">
                        <el-form-item :label="'分析对象'+(eventIndex+1)+'：'" label-width="120px" :prop="`events.${eventIndex}.eventValue`" :rules="{ required: true, message: '请选择分析对象', trigger: ['change','blur']}">
                            <el-cascader size="small" :ref="'eventsCascader-'+eventIndex" :props="{ expandTrigger: 'hover', value:'label' }" v-model="eventItem.eventValue" :options="ruleData.eventsList"  filterable clearable :show-all-levels="false" placeholder="请选择" style="width:220px" @change="handleEvent($event, eventIndex, eventItem)" :disabled="ifupdate"></el-cascader>
                        </el-form-item>
           
                        <span class="el-form-item">&nbsp;的&nbsp;</span>

                        <el-form-item :prop="`events.${eventIndex}.seletedValue`" :rules="{ required: true, message: '请选择分析对象', trigger: ['change','blur']}">
                            <el-cascader size="small" :ref="'selectedCascader-'+eventIndex" :props="selectProps" v-model="eventItem.seletedValue" :options="eventItem.selectList" filterable clearable placeholder="请选择" style="width:330px" @change="handleSelected($event, eventIndex)"></el-cascader>
                        </el-form-item>

                        <span class="el-form-item termButn" v-if="eventItem.eventValue.length > 0" @click="handleAddScreen(eventIndex)"><svg-icon icon-class="tiaojian" />筛选条件</span>

                        <!-- <i class="el-icon-circle-plus-outline icon termButn addButn"  @click="handleAddEvent"></i> -->

                        <!-- <i class="el-icon-circle-close icon termButn deleteButn" v-if="ruleData.events.length > 1" @click="handleDeleteEvent(eventIndex)"></i> -->
                    </div>

                    <!-- where 条件box-->
                    <div class="condition-box" v-if="eventItem.whereData.data && eventItem.whereData.data.length>0 && eventItem.eventValue.length > 0" >
                        <span v-if="eventItem.whereData.data && eventItem.whereData.data.length > 1" class="whereAccord" @click="handleWhereAccord(eventItem.whereData,1)">{{eventItem.whereData.type | typeFilter}}</span>

                        <div class="box">
                            <div v-if="eventItem.whereData.data && eventItem.whereData.data.length > 1" class="group-box-line" :style="{'top':eventItem.whereData.data[0].data.length*51/2+'px','bottom':eventItem.whereData.data[eventItem.whereData.data.length-1].data.length*51/2+'px'}"></div>
                            <div class="group-box" v-for="(whereItem,whereIndex) in eventItem.whereData.data" :key="whereIndex">
                                <span class="whereAccord" v-if="whereItem.data && whereItem.data.length > 1" @click="handleWhereAccord(whereItem,2)">{{whereItem.type | typeFilter}}</span>

                                <div class="box">
                                    <div class="data-box" v-for="(dataItem,dataIndex) in whereItem.data" :key="dataIndex">
                                        <el-form-item :prop="`events.${eventIndex}.whereData.data.${whereIndex}.data.${dataIndex}.whereValue`" :rules="{ required: true, message: '请选择对象', trigger: ['change','blur']}">
                                            <el-cascader size="small" :ref="'whereCascader-'+eventIndex +'-'+whereIndex+'-'+dataIndex" :props="whereProps" v-model="dataItem.whereValue" :options="eventItem.whereList" filterable clearable placeholder="请选择" style="width:200px" @change="handleWhere($event, eventIndex, whereIndex, dataIndex)"></el-cascader>
                                        </el-form-item> &nbsp;

                                        <el-form-item :prop="`events.${eventIndex}.whereData.data.${whereIndex}.data.${dataIndex}.oper`" :rules="{ required: true, message: '请选择运算符', trigger: ['change','blur']}">
                                            <el-select size="small" v-model="dataItem.oper" placeholder="请选择" style="width:120px">
                                                <el-option v-for="item in symbolOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                            </el-select> 
                                        </el-form-item> &nbsp;
                                        
                                        <el-form-item :prop="`events.${eventIndex}.whereData.data.${whereIndex}.data.${dataIndex}.values`" :rules="{ required: true, message: '请输入值', trigger: ['change','blur']}">
                                            <div class="input-box" @click="handleTagFocus(eventIndex,whereIndex,dataIndex)">
                                                <el-tag v-for="(tag,tagIndex) in dataItem.values" :key="tagIndex" effect="plain" closable @close="handleClose(tagIndex,dataItem,eventIndex,whereIndex,dataIndex)">{{tag}}</el-tag>
                                                <el-input v-if="dataItem.values.length <= 10" size="mini" class="input-new-tag" :ref="'saveTagInput-'+eventIndex+'-'+whereIndex+'-'+dataIndex" v-model="dataItem.inputValue"  @keyup.enter.native="handleInputConfirm(dataItem.inputValue,dataItem)" @blur="handleInputConfirm(dataItem.inputValue,dataItem)"></el-input>
                                            </div>
                                        </el-form-item>

                                        <i class="el-icon-circle-plus-outline icon termButn addButn" style="margin-bottom:7px; margin-top:7px" @click="handleAddWhere(eventIndex, whereIndex)"></i>

                                        <i class="el-icon-circle-close icon termButn deleteButn" style="margin-bottom:7px; margin-top:7px" @click="handleAeleteWhere(eventIndex, whereIndex, dataIndex)"></i>

                                        <template v-if="whereItem.data && whereItem.data.length > 1">
                                            <div v-if="dataIndex==0" class="first-line" :style="{'height':51*whereItem.data.length/2 + 'px'}"></div>
                                            <div v-else-if="dataIndex==whereItem.data.length-1" class="last-line" :style="{'height':51*dataIndex/2 + 'px'}"></div>
                                            <div v-else class="line"></div>
                                        </template>
                                    </div>
                                </div>

                                <template v-if="eventItem.whereData.data && eventItem.whereData.data.length > 1">
                                    <div v-if="whereIndex==0" class="group-first-line" :style="{'top':eventItem.whereData.data[0].data.length*51/2+'px'}"></div>
                                    <div v-else-if="whereIndex==eventItem.whereData.data.length-1" class="group-last-line" :style="{'bottom':eventItem.whereData.data[eventItem.whereData.data.length-1].data.length*51/2+'px'}"></div>
                                    <div v-else class="group-line" :style="{'top':51*whereItem.data.length/2+'px'}"></div>
                                </template>

                            </div>
                        </div>
                    </div>
                </div> 

                <!-- 规则 joins -->
                <div class="rules-box">
                    <div class="rules-list filter-data">
                        <el-form-item label="规则：" label-width="120px" prop="leftIndex" :rules="{ required: true, message: '请选择规则对象', trigger: ['change','blur']}">
                            <el-select :disabled="ifupdate" size="small" v-model="ruleData.leftIndex" placeholder="请选择" style="width:200px">
                                <el-option label="对象1" :value="1"></el-option>
                                <el-option label="对象2" :value="2"></el-option>
                            </el-select> 
                        </el-form-item> &nbsp;

                        <el-form-item  prop="executeType" :rules="{ required: true, message: '请选择JOIN', trigger: ['change','blur']}">
                            <el-select :disabled="ifupdate" size="small" v-model="ruleData.executeType" placeholder="请选择" style="width:200px">
                                <el-option label="LEFT JOIN" value="left join"></el-option>
                                <el-option label="RIGHT JOIN" value="right join"></el-option>
                                <el-option label="INNER JOIN" value="inner join"></el-option>
                                <el-option label="Full JOIN" value="full join"></el-option>
                                <el-option label="UNION" value="union"></el-option>
                                <el-option label="UNION ALL" value="union all"></el-option>
                            </el-select> 
                        </el-form-item> &nbsp;

                        <el-form-item  prop="rightIndex" :rules="{ required: true, message: '请选择规则对象', trigger: ['change','blur']}">
                            <el-select :disabled="ifupdate" size="small" v-model="ruleData.rightIndex" placeholder="请选择" style="width:200px">
                                <el-option label="对象1" :value="1"></el-option>
                                <el-option label="对象2" :value="2"></el-option>
                            </el-select> &nbsp;
                        </el-form-item>

                        <span class="el-form-item termButn" @click="handleAddJoins"><svg-icon icon-class="tiaojian" />筛选条件</span>
                    </div>

                    <div class="condition-join-box" v-if="ruleData.joins && ruleData.joins.length > 0" >
                        <span v-if="ruleData.joins && ruleData.joins.length > 1" class="whereAccord" >且</span>
                        <div class="box">
                            <div class="join-box" v-for="(joinsItem,joinsIndex) in ruleData.joins" :key="joinsIndex">
                                <template v-for="(join,joinIndex) in joinsItem">
                                    <el-form-item :key="joinIndex" :label="'对象'+(joinIndex+1)+'：'" label-width="75px" :prop="`joins.${joinsIndex}.${joinIndex}.joinValue`" :rules="{ required: true, message: '请选择对象', trigger: ['change','blur']}">
                                        <el-cascader size="small" :ref="'joinCascader-'+joinsIndex +'-'+joinIndex" v-model="join.joinValue" :options="joinIndex == 0 ? ruleData.joinsList_1 : ruleData.joinsList_2" :show-all-levels="false" filterable clearable placeholder="请选择" @change="handleJoin($event,joinsIndex,joinIndex)" style="width:200px"></el-cascader>
                                    </el-form-item>
                                    &nbsp;&nbsp;&nbsp;
                                </template>
                                <i class="el-icon-circle-close icon termButn deleteButn" style="margin-bottom:7px; margin-top:7px" @click="handleAeleteJoin(joinsIndex)"></i>

                                <template v-if="ruleData.joins && ruleData.joins.length > 1">
                                    <div v-if="joinsIndex==0" class="first-line" :style="{'height':51*ruleData.joins.length/2 + 'px'}"></div>
                                    <div v-else-if="joinsIndex==ruleData.joins.length-1" class="last-line" :style="{'height':51*joinsIndex/2 + 'px'}"></div>
                                    <div v-else class="line"></div>
                                </template>
                            </div>
                        </div>
                            
                    </div>

                </div>

                <!-- 更新方式 -->
                <el-form-item label="更新方式：" label-width="120px" prop="outputMode" :rules="{required: true, message: '请选择更新方式', trigger: ['change','blur']}">
                    <el-radio-group v-model="ruleData.outputMode">
                        <el-radio v-for="item in outputModeOptions"  :disabled="ifupdate" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
       
        <!-- 按钮组 -->
        <div class="butn-box" style="text-align: right; margin-top:10px">
            <el-button size="small" @click="jump('upper')">上一步</el-button>
            <el-button size="small" type="primary" @click="jump('lower')" >下一步</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sourceData: {
            type: Object,
            default: () => {}
        },

        selectProps: {
            type: Object,
            default: () =>{}
        },

        whereProps: {
            type: Object,
            default: () =>{}
        },
        
        symbolOption: {
            type: Array,
            default: () =>[]
        },
        ifupdate: {
            type: Boolean,
            default:false
        }
    },

    watch: {
        sourceData(val) {
            // console.log('初始化数据',val)
            this.ruleData = val 
        },

        // 规则左边值
        'ruleData.leftIndex'(val) {
            // console.log('左边规则值：',val)
            if(val == 1) {
                this.ruleData.rightIndex = 2
            } else {
                this.ruleData.rightIndex = 1
            }
        },

        // 规则右边值
        'ruleData.rightIndex'(val) {
            // console.log('右边规则值：',val)
            if(val == 1) {
                this.ruleData.leftIndex = 2
            } else {
                this.ruleData.leftIndex = 1
            }
        }
    },

    data() {
        return {
            ruleData:{},
            outputModeOptions:[{id:'overwrite',name:'覆盖'},{id:'append',name:'追加'}],
        }
    },

    filters: {
        // 关系条件
        typeFilter(type) {
            const typeMap = {
                'AND': '且',
                'OR': '或'
            }
            return typeMap[type]
        },
    },

    methods: {
        // 转化数据
        transformData(val) {

        },

        // 新增对象
        handleAddEvent() {
            const data = {
                eventCode: '',
                selectData: []
            }

            this.ruleData.events.push(data)
        },

        // 删除对象
        handleDeleteEvent(index) {
            this.ruleData.events.splice(index, 1)
        },

        // where条件 且或的切换
        handleWhereAccord(item,level) {
            // console.log('且或====',item.type)
            if(item.type == 'AND') {
                item.type = 'OR'
            } else {
                item.type = 'AND'
            }

            if(level == 2) {
                item.data.forEach(v => {
                    v.type = item.type
                })
            }
           
        },

        // 新增where 筛选
        handleAddScreen(index) {
            const data = {
                type:'AND',
                data: [
                    {
                        dataKey: '',
                        oper: '',
                        values:[],
                        type:'',
                        inputValue:'',
                        whereValue:[]
                    }
                ]
            }
            this.ruleData.events[index].whereData.data.push(data)
        },

        // 新增 where 条件
        handleAddWhere(eventIndex, whereIndex) {
            const data = {
                dataKey: '',
                oper: '',
                values:[],
                type:'',
                inputValue:'',
                whereValue:[]
            }
            // console.log(eventIndex, whereIndex)
            this.ruleData.events[eventIndex].whereData.data[whereIndex].data.push(data)
        },

        // 删除 where条件
        handleAeleteWhere(eventIndex, whereIndex, dataIndex) {
            this.ruleData.events[eventIndex].whereData.data[whereIndex].data.splice(dataIndex,1)
            if(this.ruleData.events[eventIndex].whereData.data[whereIndex].data.length == 0) {
                this.ruleData.events[eventIndex].whereData.data.splice(whereIndex, 1)
            }

            // console.log(this.ruleData)
        },

        // tag 
        handleInputConfirm(val,dataItem) {
            let inputValue = val
            if(inputValue) {
                dataItem.values.push(inputValue)
            }
            dataItem.inputValue = ''
        },
        handleClose(index,dataItem,eventIndex,whereIndex,dataIndex) {
            dataItem.values.splice(index,1)
           this.handleTagFocus(eventIndex,whereIndex,dataIndex)
        },

        handleTagFocus(eventIndex,whereIndex,dataIndex){
            const saveTagInput = 'saveTagInput-'+eventIndex+'-'+whereIndex+'-'+dataIndex
            this.$nextTick(_ => {
                this.$refs[saveTagInput][0].$refs['input'].focus()
            })
        },

        // 新增规则
        handleAddJoins() {
            const data = [
                {
                   dataKey:'',
                   mapField:'',
                   type: '',
                   joinValue:[]
                },
                {
                   dataKey:'',
                   mapField:'',
                   type: '',
                   joinValue:[]
                }
            ]

            this.ruleData.joins.push(data)
        },

        // 删除规则 join
        handleAeleteJoin(joinsIndex) {
            this.ruleData.joins.splice(joinsIndex, 1)
        },

        // 操作选择对象 event
        handleEvent(val,eventIndex,eventItem) {
            // console.log('====',val,eventIndex,eventItem)
            const eventsCascader = 'eventsCascader-'+eventIndex
            this.$nextTick(_ => {
                let item = this.$refs[eventsCascader][0].getCheckedNodes()
                // console.log('选中的event item: ',item[0])
                this.listenEventRule(eventIndex,item[0])

                eventItem.seletedValue = []
                eventItem.selectData = []
                eventItem.selectList = []                    
                eventItem.whereList = []
                eventItem.whereData = {
                    type: 'AND',
                    data:[]
                }

                if(eventIndex == 0) {
                    this.ruleData.joinsList_1 = []
                } else {
                    this.ruleData.joinsList_2 = []
                }

                if(item[0]) {
                    this.$emit('changeEvent',item[0], eventIndex)
                }
            })
        },

        // 操作 event 的 selected
        handleSelected(val,eventIndex) {
            // console.log(val,eventIndex)
            const selectedCascader = 'selectedCascader-'+eventIndex
            let item = this.$refs[selectedCascader][0].getCheckedNodes()
            // console.log('选中的selected item: ',item)
            this.listenSelectRule(eventIndex,item)
        },

        // 操作 event 的 where
        handleWhere(val, eventIndex, whereIndex, dataIndex) {
            // console.log(val)
            const whereCascader = 'whereCascader-'+eventIndex +'-'+whereIndex+'-'+dataIndex
            let item = this.$refs[whereCascader][0].getCheckedNodes()
            //console.log('选中的where item: ',item)
            this.listenWhereRule(eventIndex,whereIndex,dataIndex,item[0])
        },

        // 操作 join 
        handleJoin(val,joinsIndex,joinIndex) {
            
            const joinCascader = 'joinCascader-'+joinsIndex +'-'+joinIndex
            let item = this.$refs[joinCascader][0].getCheckedNodes()
            // console.log('选中的join item: ',item[0])
            this.listenJoinRule(joinsIndex,joinIndex,item[0])
        },

        // event 改变时 监听提交rule值
        listenEventRule(eventIndex,eventItem) {
            const data = this.ruleData.events[eventIndex]

            if(eventItem) {
                data.eventCode = eventItem.data.value
                data.platformType = eventItem.data.platformType
                data.tableId = eventItem.data.tableId
            } else {
                data.eventCode = ''
                data.platformType = ''
                data.tableId = ''
            }
            
             // console.log('选择的对象：',this.ruleData.events[eventIndex])
        },

        // selected 改变时 监听提交rule值
        listenSelectRule(eventIndex,selectedItem) {
            const data = this.ruleData.events[eventIndex]
            const selecteds = []
            selectedItem.forEach(item => {
                let data = {}
                if(item.level == 1) {
                    data = {
                        dataKey: item.data.value,
                        mapField:item.data.mapField,
                        type:item.data.dataType
                    }
                } else {
                    data = {
                        compute: item.data.value,
                        dataKey: item.pathNodes[0].data.value,
                        mapField:item.pathNodes[0].data.mapField,
                        type:item.pathNodes[0].data.dataType
                    }
                }
                selecteds.push(data)
            })

            data.selectData = selecteds

            // console.log('选择的对象：',this.ruleData.events[eventIndex])
           
        },

        // where 改变时 监听提交的rule值
        listenWhereRule(eventIndex,whereIndex,dataIndex,whereItem){
            const data = this.ruleData.events[eventIndex].whereData.data[whereIndex].data[dataIndex]
            if(!whereItem) {
                data.dataKey = ''
                this.$delete(data,'compute')
            } else {
                if(whereItem.level == 1) {
                    data.dataKey = whereItem.data.value
                } else {
                    data.compute = whereItem.data.value
                    data.dataKey = whereItem.pathNodes[0].data.value
                }
            }

            data.type = this.ruleData.events[eventIndex].whereData.data[whereIndex].type 

            // console.log('选择的对象：',this.ruleData.events[eventIndex])
        },

        // join改变时 监听提交的rule值
        listenJoinRule(joinsIndex,joinIndex,joinItem) {
            const data = this.ruleData.joins[joinsIndex]
            if(joinItem) {
                if(joinItem.level > 1) {
                    data[joinIndex].compute = joinItem.data.value
                    data[joinIndex].dataKey = joinItem.pathNodes[0].data.value
                    data[joinIndex].mapField = joinItem.pathNodes[0].data.mapField
                    data[joinIndex].type = joinItem.pathNodes[0].data.dataType
                } else {
                    data[joinIndex].dataKey = joinItem.data.value
                    data[joinIndex].mapField = joinItem.data.mapField
                    data[joinIndex].type = joinItem.data.dataType
                }
            } else {
                this.$delete(data[joinIndex],'compute')
                data[joinIndex].dataKey = ''
                data[joinIndex].mapField = ''
                data[joinIndex].type = ''
            }
        
            // console.log('选择的对象：',this.ruleData)
        },

        // 操作跳转
        jump(para) {
            this.$emit('jump',para,this.ruleData)
        }
    }
}
</script>

<style lang="scss" scoped>
    .filter-container{
        .analy-box{
            // margin-bottom: 10px;
        }
        .filter-data, .condition, .rules-list,.input-box, .join-box{
            display: flex;
            flex-flow: row wrap;
            justify-content: flex-start;
            align-items: center;
        }
        .termButn{
            margin-left: 8px;
            margin-right: 8px;
            cursor: pointer;
        }
        .icon {
            font-size: 22px;
        }
        .addButn{
            color: #409EFF;
        }
        .deleteButn{
            color: #F56C6C;
        }

        .condition-box{
            margin: 10px 0 10px;
            width: 100%;
            background: #dbdfe7;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            
            .box{
                position: relative;
            }
            .group-box-line{
                width: 1px;
                border-left: 1px solid#c3c1c1;
                position:absolute;
                left: -45px;
                top: 40px;
                bottom: 40px;
            }
            .group-box{
                // margin: 5px 0;
                display: flex;
                flex-flow: row nowrap;
                justify-content: center;
                align-items: center;
                position: relative;
                .group-line{
                    width: 75px;
                    position:absolute;
                    left: -45px;
                    top: 21px;
                    border-top: 1px solid #c3c1c1;
                    border-left: 1px solid#c3c1c1;
                    z-index: 0;
                }
                .group-first-line{
                    width: 75px;
                    position:absolute;
                    top: 21px;
                    left: -45px;
                    border-top: 1px solid #c3c1c1;
                    border-left: 1px solid#c3c1c1;
                }
                .group-last-line{
                    width: 75px;
                    position:absolute;
                    bottom: 21px;
                    left: -45px;
                    border-bottom: 1px solid #c3c1c1;
                    border-left: 1px solid#c3c1c1;
                }
            }

            .data-box{
                margin: 0px 0 0px;
                display: flex;
                flex-flow: row wrap;
                justify-content: center;
                align-items: center;
                position: relative;
                z-index: 1;

                // .line{
                //     position:absolute;
                //     left: -45px;
                //     top: 25.5px;
                //     width: 45px;
                //     border-top: 1px solid #c3c1c1;
                // }
                // .first-line{
                //     position:absolute;
                //     left: -45px;
                //     top: 25.5px;
                //     width: 45px;
                //     border-top: 1px solid #c3c1c1;
                //     border-left: 1px solid#c3c1c1;
                // }
                // .last-line{
                //     position:absolute;
                //     left: -45px;
                //     bottom: 25.5px;
                //     width: 45px;
                //     border-bottom: 1px solid #c3c1c1;
                //     border-left: 1px solid#c3c1c1;
                // }
            }
            
            .condition{
                margin: 5px 0;
            }
            
            .input-box{
                flex-flow: row nowrap;
                width: 280px;
                height: 32px;
                background-color: #fff;
                background-image: none;
                border-radius: 4px;
                border: 1px solid #dcdfe6;
                box-sizing: border-box;
                ::v-deep .el-tag{
                    border:0;
                    border-radius: 0px;
                    padding: 0 6px;
                }
                .input-new-tag {
                    width: 80px;
                    margin-left: 3px;
                    vertical-align: bottom;
                    ::v-deep .el-input__inner{
                        border-radius: 0px;
                        border: 0;
                        padding: 0 6px;
                    }
                }
            }
        }

        .whereAccord{
            display: block;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #fff;
            border: 1px solid #c3c1c1;
            cursor: pointer;
            margin-right: 30px;
            position: relative;
            z-index: 2;
        }

        .line{
            position:absolute;
            left: -45px;
            top: 25.5px;
            width: 45px;
            border-top: 1px solid #c3c1c1;
        }
        .first-line{
            position:absolute;
            left: -45px;
            top: 25.5px;
            width: 45px;
            border-top: 1px solid #c3c1c1;
            border-left: 1px solid#c3c1c1;
        }
        .last-line{
            position:absolute;
            left: -45px;
            bottom: 25.5px;
            width: 45px;
            border-bottom: 1px solid #c3c1c1;
            border-left: 1px solid#c3c1c1;
        }

        .condition-join-box{
            margin: 5px 0 10px;
            width: 100%;
            background: #dbdfe7;
            // padding: 10px 0 5px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;

            .join-box{
                position: relative;
            }
        }

        ::v-deep .el-form-item__error{
            padding-top:2px;
            padding-left: 10px;
        }

        ::v-deep .el-form-item {
            margin-bottom: 7px;
            margin-top: 7px;
        }

    }
</style>